<template>
  <div class="create-letter">
    <div>
      <div class="mobile-field" v-if="isMobile().any">
        <div class="form-group">
          <label for="title">{{ $t('create.th.title') }}</label>
          <input class="form-control" type="text" id="title" v-model="letter.title">
        </div>
        <div class="form-group">
          <label for="date">{{ $t('create.th.when') }}</label>
          <input class="form-control" type="date" id="date" v-model="letter.received_date">
        </div>
        <!-- <label for="content">内容</label>
        <textarea class="form-control" name="name" rows="8" cols="80" v-model="letter.content"></textarea> -->
      </div>
      <div class="pc-field" v-else>
        <table class="table table-bordered">
          <tbody>
            <tr>
              <th>{{ $t('create.th.title') }}</th>
              <td>
                <input type="text" class="form-control" v-model="letter.title">
              </td>
            </tr>
            <tr>
              <th>{{ $t('create.th.when') }}</th>
              <td>
                <input type="date" class="form-control" v-model="letter.received_date">
              </td>
            </tr>
            <!-- <tr>
              <th>内容</th>
              <td>
                <textarea class="form-control" rows="8" cols="80" v-model="letter.content"></textarea>
              </td>
            </tr> -->
          </tbody>
        </table>
      </div>
    <div class="preview">
      <Letter :selectedLetter="letter" :isWrite="true" />
      <!-- <button type="button" name="button" @click="isPreview=false" class="btn-gradient-3d-simple">戻る</button> -->
    </div>
      <!-- <button type="button" name="button" @click="isPreview=true" class="btn-gradient-3d-orange">preview</button> -->
    </div>
    <button type="button" class="btn-circle-fishy" name="button" @click="createLetter">{{ $t('create.button.send') }}</button>
    <div id="overlay" v-if="complete_create">
      <div class="overlay-contents">
        <div class="center">
          {{ $t('create.message.complete') }}
          <button type="button" name="button" class="btn btn-info" @click="complete_create = false">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import isMobile from 'ismobilejs'
import firebase from 'firebase'
import Letter from '@/components/Letter.vue'


export default {
  name: 'create-letter',
  components: {
    Letter
  },
  data() {
    return {
      isMobile,
      db: null,
      letter: {title:'', send_date: '', received_date: null, content: '', is_read: false, uid: null},
      uid: null,
      isPreview: false,
      complete_create: false
    }
  },
  methods: {
    createLetter(){
      this.letter.send_date = new Date();
      this.letter.received_date = new Date(this.letter.received_date);
      // this.$store.commit('createLetter', this.letter);
      let vue = this;
      firebase.auth().onAuthStateChanged(user=>{
        if (user){
          vue.db.collection('letters').add(vue.letter).then((docRef)=>{
            vue.db.collection('users').doc(user.uid).collection('letters').doc(docRef.id).set({
              title: vue.letter.title,
              received_date: vue.letter.received_date,
              is_read: vue.letter.is_read
            });
            vue.letter = {title:'', send_date: '', received_date: null, content: '', is_read: false, uid: this.uid};
            vue.complete_create = true;
          });
        }
      });
    }
  },
  created: function(){
    this.db = firebase.firestore();
    let vue = this;
    firebase.auth().onAuthStateChanged(user=>{
      if (user){
        vue.uid = user.uid;
        vue.letter.uid = user.uid;
      }
    });
  }
}
</script>
<style scoped>
button {
  border: 0;
}
.btn-gradient-3d-simple {
  display: inline-block;
  padding: 0.5em 1em;
  text-decoration: none;
  border-radius: 4px;
  color: #ffffff;
  background-image: linear-gradient(#6795fd 0%, #67ceff 100%);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.29);
  border-bottom: solid 3px #5e7fca;
}

.btn-gradient-3d-simple:active {
  -webkit-transform: translateY(4px);
  transform: translateY(4px);
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.2);
  border-bottom: none;
}

.btn-gradient-3d-orange {

  display: inline-block;
  padding: 0.5em 1em;
  text-decoration: none;
  border-radius: 4px;
  color: #ffffff;
  background-image: linear-gradient(45deg, #FFC107 0%, #ff8b5f 100%);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.29);
  border-bottom: solid 3px #c58668;
}

.btn-gradient-3d-orange:active {
  -webkit-transform: translateY(4px);
  transform: translateY(4px);
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.2);
  border-bottom: none;
}

.btn-circle-fishy {
  display: inline-block;
  text-decoration: none;
  color: #FFF;
  width: 120px;
  height: 120px;
  line-height: 120px;
  border-radius: 50%;
  text-align: center;
  overflow: hidden;
  background-image: linear-gradient(45deg, #709dff 0%, #91fdb7 100%);
  transition: .4s;
}

.btn-circle-fishy:hover {
  -webkit-transform: rotate(10deg);
  transform: rotate(10deg);
}

#overlay {
  z-index:1;
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay-contents {
  position: relative;
  z-index: 2;
  width: 50%;
  height: 50%;
  background: white;
  margin: 0 auto;
}

.center {
  margin: 0;
  font-size: 20px;
  width: 100%;
  text-align: center;
  position: absolute;               /* 2 */
  top: 50%;                         /* 3 */
  transform: translate(0, -50%)
}
</style>
